import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { AutoComplete, Checkbox, Form, Input, Radio, Card, Divider, Steps, Select, Tag, Image, Row, Col, List, Avatar, DatePicker, Dropdown, Button, Menu, Typography, Space } from 'antd';
import './index.css';
import Navbar from '../../layouts/navbar';
import Footer from '../../layouts/footer';
import Slider from "react-slick";
import { InfoCircleOutlined, CalendarOutlined, CreditCardOutlined, SolutionOutlined, WifiOutlined, CheckCircleOutlined, CheckOutlined, EnvironmentOutlined, MessageOutlined, LikeOutlined, StarOutlined } from '@ant-design/icons';
import { AiOutlineWifi } from "react-icons/ai";
import { FaShower, FaSmokingBan } from "react-icons/fa";
import { RiWindyFill } from "react-icons/ri";
import Lottie from 'lottie-react-web';
import checkmark from '../../checkmark.json';
import failed from '../../failed.json';
import { useNavigate, useLocation } from 'react-router-dom';
import { mstAuth, mstGeneral } from '../../mobx';
import { useReferral } from '../../utils/referral';

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

const OtpScreen = (props) => {
	const {navigateWithReferral} = useReferral();
  const navProps = useLocation()
  const [loggingIn, setLoggingIn] = useState(false)
	const [otp, setOtp] = useState('')

	const onLogin = () => {
		const params = {
			UUID: navProps.state.uuid,
      OTP: otp
		};
		console.log("check params ===> ", navProps)
		setLoggingIn(true)
		mstAuth.registrationVerify(params)
		.then((response) => {
			setLoggingIn(false)
			console.log("check response ===> ", response)
      alert("You have succesfully registered. Login now to start booking.")
      navigateWithReferral('/reservation/login')
		})
		.catch((error) => {
			setLoggingIn(false)
			alert(`[${error.error_code}] ${error.error_message}`)
		})
		// setLoggingIn(true)
		// setTimeout(() => {
		// 	setLoggingIn(false)
		// }, 3000)
	};

	const onChangeInput = (type, value) => {
		if (type === 'otp') {
			setOtp(value)
		}
	};

  console.log("props ==> ", props)

	return (
		<div id="OtpScreen">
			<div className="container">
				<Navbar />
				<React.Fragment>
          <div className="pageTitleWrapper">
            <Text className="pageTitle">Otp Verification</Text>
          </div>
          <Divider className="pageTitleDivider" />
          <Form
            name="basic"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            initialValues={{ remember: true }}
            style={{ marginTop: '1em' }}
            // onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Text style={{ marginTop: '1em' }}>We have sent OTP code to your email, <b>{navProps.state?.email}</b></Text>
            <Form.Item
              // label="OTP"
              name="otp"
              rules={[{ required: true, message: 'Required' }]}
              style={{ marginTop: '1em' }}
            >
              <Input onChange={(event) => { onChangeInput("otp", event.target.value) }} />
            </Form.Item>
            
            <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
              <Button type="primary" loading={loggingIn} htmlType="submit" onClick={() => { onLogin() }}>
                Submit
              </Button>
              <Button type="link" onClick={() => { navigateWithReferral('/reservation/login') }}>
                Go to Login
              </Button>
            </Form.Item>
          </Form>
        </React.Fragment>
	    </div>
	    <Footer />
		</div>
	)
};

export default OtpScreen;